<template>
  <div class="testimonials base-container">
    <h2>{{ heading }}</h2>
    <div class="py-4"></div>
    <div class="testimonial-container">
      <div class="image">
        <img
          v-for="(item, index) in testimonialsItems"
          v-bind:key="item.id"
          :src="item.image ? item.image.url : '/img/img_placeholder.svg'"
          :alt="item.image ? item.image.alt : 'Platzhalter'"
          :class="{ active: currentItemIndex === index }"
        />
      </div>
      <div class="swiper-container" ref="slider">
        <div class="swiper-wrapper">
          <div
            v-for="item in testimonialsItems"
            v-bind:key="item.id"
            class="swiper-slide"
          >
            <div class="bard sub-bard" v-html="item.text"></div>
            <div class="py-3"></div>
            <div class="w-full">
              <strong>{{ item.title }}</strong>
            </div>
          </div>
        </div>
        <div class="swiper-button-prev">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 16 16"
            width="16"
            height="16"
          >
            <path
              fill="currentColor"
              d="M3.86 8.753l5.482 4.796c.646.566 1.658.106 1.658-.753V3.204a1 1 0 00-1.659-.753l-5.48 4.796a1 1 0 000 1.506z"
            />
          </svg>
        </div>
        <div class="swiper-button-next">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 16 16"
            width="16"
            height="16"
          >
            <path
              fill="currentColor"
              d="M12.14 8.753l-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 011.659-.753l5.48 4.796a1 1 0 010 1.506z"
            />
          </svg>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as GLOBALS from "../globals";
import Swiper, { Autoplay, Navigation } from "swiper";
Swiper.use([Autoplay, Navigation]);

export default {
  props: {
    heading: String,
    items: String,
  },
  data() {
    return {
      currentItemIndex: 0,
      testimonialsItems: JSON.parse(this.items) ?? {},
    };
  },
  mounted() {
    const swiper = new Swiper(this.$refs.slider, {
      slidesPerView: 1,
      spaceBetween: 50,
      autoHeight: true,
      autoplay: {
        delay: 18000,
        pauseOnMouseEnter: true,
        disableOnInteraction: false,
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      on: {
        slideChange: (swiper) => {
          this.currentItemIndex = swiper.realIndex;
        },
      },
    });
  },
};
</script>
